import { defineStore } from 'pinia'
import { successAlert,errorAlert } from '../plugins/alert'

export const useBatchStore = defineStore('batch', {
    state: () => ({
        batch_notify_list:[],
        access_time:null,
        loading:false,
        error:null,
    }),
    actions: {
        async readed(ids) {
            try {
                //loading を true に
                this.loading = true
                const formData = new FormData();
                for (let i=0;i<this.batch_notify_list.length;i++) {
                    formData.append('ids',this.batch_notify_list[i].id);
                }
                await fetch((<HTMLInputElement>document.getElementById('batch_apis_pharmacy_batch_readed_update')).value,{
                    method: 'post',
                    headers: {
                        'Tokiwa-Api-Key': <string>(document.getElementsByName('tokiwa_api_key').length == 0 ? '' : (!document.getElementsByName('tokiwa_api_key')[0].getAttribute('content') ? "" :  document.getElementsByName('tokiwa_api_key')[0].getAttribute('content'))),
		                'X-CSRFToken' : <string>(document.getElementsByName('csrf_token').length == 0 ? '' : (!document.getElementsByName('csrf_token')[0].getAttribute('content') ? "" :  document.getElementsByName('csrf_token')[0].getAttribute('content'))),
                    },
                    body: formData
                })
                .then((response) => response.json())
                .then((data) => {
                    //特に何もしない
                });
            } catch (error) {
                this.error = error
            } finally {
                this.loading = false
            }
        },
        async fetchUnread() {
            try {
                //負荷を下げるためせめて1分に1回にする
                let now_time = new Date();
                if ((this.access_time != null) && (this.access_time.getTime() + (1000*60) > now_time.getTime())) {
                    return;
                }
                //posts を初期化（ストアのインスタンスには this でアクセス）
                this.access_time = now_time;
                this.batch_notify_list = []
                //loading を true に
                this.loading = true
                await fetch((<HTMLInputElement>document.getElementById('batch_apis_pharmacy_batch_list_unread')).value,{
                    headers: {
                        'Tokiwa-Api-Key': <string>(document.getElementsByName('tokiwa_api_key').length == 0 ? '' : (!document.getElementsByName('tokiwa_api_key')[0].getAttribute('content') ? "" :  document.getElementsByName('tokiwa_api_key')[0].getAttribute('content'))),
                    }
                })
                .then((response) => response.json())
                .then((data) => {
                    this.batch_notify_list = data.batch_notify_list;
                    let batch_ids = [];
                    if (this.batch_notify_list.length > 0) {
                        let error_message = '';
                        let success_message = '';
                        for (let i=0;i<this.batch_notify_list.length;i++) {
                            batch_ids.push(this.batch_notify_list[i].id);
                            if (this.batch_notify_list[i].error_status == 0) {
                                success_message += this.batch_notify_list[i].result_message + "\n";
                            } else {
                                error_message += this.batch_notify_list[i].result_message + "\n";
                            }
                        }
                        if (success_message) {
                            successAlert(success_message.replace("\n",'<br>'),async () => {
                                await this.readed(batch_ids);
                            });
                        }
                        if (error_message) {
                            errorAlert(error_message.replace("\n",'<br>'),async () => {
                                await this.readed(batch_ids);
                            });
                        }
                    }
                });
            } catch (error) {
                this.error = error
            } finally {
                this.loading = false
            }
        }
    }
})
